import mixpanel from "mixpanel-browser";
import { User } from "../interfaces/User";
import Logger from "./sentry";
import { getLastLocation } from "../utils/links";
import { handleError } from "../errors";
import { VERSION } from "../config/version";
import { browserStore } from "../utils/storageKeys";

type MixpanelConfig = {
  token: string;
  apiHost: string;
};

const NON_PROD_MIXPANEL_CONFIG: MixpanelConfig = {
  token: "540d970149de5ce36cfaa95661401337",
  apiHost: "https://events.stage.ediphi.com",
};

const PROD_MIXPANEL_CONFIG: MixpanelConfig = {
  token: "907da647e4fa4f589b95a9fe2c7885e9",
  apiHost: "https://events.ediphi.com",
};

const isProd = window.location.hostname === "excel.ediphi.com";
const MIXPANEL_CONFIG: MixpanelConfig = isProd ? PROD_MIXPANEL_CONFIG : NON_PROD_MIXPANEL_CONFIG;
const MIXPANEL_ENABLED = !!MIXPANEL_CONFIG.token && !!MIXPANEL_CONFIG.apiHost;

if (MIXPANEL_ENABLED) {
  mixpanel.init(MIXPANEL_CONFIG.token, { api_host: MIXPANEL_CONFIG.apiHost });
}

export const track = async (event: string, data?: Record<string, unknown>) => {
  let user: User | null = null;
  try {
    if (!MIXPANEL_ENABLED || !mixpanel.track) return;
    const userProfile = browserStore.get("userProfile");
    user = userProfile ? JSON.parse(userProfile) : null;
    const lastLocation = getLastLocation();

    if (!user) {
      Logger.warn("User not found in localStorage; skipping Mixpanel tracking.");
      return;
    }

    mixpanel.identify(user.id);
    mixpanel.track(event, {
      distinct_id: user.id,
      tenant: lastLocation.tenant,
      project: lastLocation.projectId,
      estimate: lastLocation.estimateId,
      gcgr: lastLocation.gcgrId,
      cost_model: lastLocation.costModelId,
      contracting: lastLocation.contractingLoaded,
      version: VERSION,
      ...data,
    });
  } catch (error) {
    // EXCEPTION: Logger error allowed here
    const err = handleError(error, { event, context: "mixpanelTrack" });
    Logger.error("Error tracking event to mixpanel", err);
  }
};
